import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';

import TouchableElement from '@components/common/touchableElement';
import LineButton from '@components/common/lineButton';
import { SmallLoading } from '@components/loading';

import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';
import Svg from '@styles/icons/svg';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default ({ C, data, getMachineConnectionMethod, validateUserAction, updateDataObj, goBack }) => {
  const [list, setList] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      const d = await getMachineConnectionMethod();
      setList(d);
      setLoaded(true);
    })();
  }, []);

  const selectControl = async (item) => {
    await validateUserAction({
      ...data,
      connectionMethodCode: item.code,
      connectionMethodName: item.name,
      automaticControl: false,
    });
  };

  return (
    <View style={{ paddingBottom: scale(20), paddingHorizontal: isPhone ? 0 : scale(15) }}>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
            <TouchableElement
              onPress={() => {
                updateDataObj({
                  connectionMethodCode: null,
                  connectionMethodName: null,
                });
                goBack();
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15), paddingHorizontal: isPhone ? scale(15) : 0, flexDirection: 'row' }]}>
                  <View style={{ marginTop: scale(2) }}>
                    <Svg icon="chevronLeft" width={scale(11)} height={scale(17)} color="Link / Light / Primary" />
                  </View>
                  <Text style={[{ color: C(pressHoverColor('System/Light/Blue')), marginLeft: scale(7) }, font.Body]}>{i18n.t('Back')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Machine Protocol')}</Text>
        </View>
      </View>
      <View style={{ marginTop: scale(20), paddingHorizontal: scale(15) }}>
        <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>{i18n.t('SELECT MACHINE PROTOCOL')}</Text>
      </View>
      {loaded ? (
        <View
          style={[
            getBoxShadowStyle({ type: 'Field', C }),
            { marginTop: scale(5), borderRadius: scale(SCREEN_BORDER_RADIUS) },
            isPhone && {
              borderColor: C('Hairline/Light/No trans'),
              borderBottomWidth: StyleSheet.hairlineWidth,
              borderTopWidth: StyleSheet.hairlineWidth,
            },
          ]}
        >
          {list.map((item, index) => (
            <LineButton
              key={item.code}
              {...{
                C,
                onPress: () => selectControl(item),
                text: item.name,
                color: 'Link/Light/Primary',
                borderRadiusTop: isPhone ? false : index === 0,
                borderRadiusBottom: isPhone ? false : index === list.length - 1,
                shadow: false,
                borderBottom: index !== list.length - 1,
              }}
            />
          ))}
        </View>
      ) : (
        <SmallLoading />
      )}
    </View>
  );
};
